/**
 * Converte caminhos de imagem em URLs absolutas com caching
 */
const API_BASE_URL =
  (typeof window !== 'undefined' && window.__REACT_APP_LOJA_API_URL) ||
  process.env.REACT_APP_LOJA_API_URL ||
  'http://localhost:4001';

// Cache em memória para evitar recomputações
const urlCache = {};

export function resolveImageUrl(imagePath) {
  if (!imagePath) return null;

  // Verifica cache em memória
  if (urlCache[imagePath]) {
    return urlCache[imagePath];
  }

  // Se já é uma URL absoluta, retorna como está
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    urlCache[imagePath] = imagePath;
    return imagePath;
  }

  // Se é um caminho relativo, adiciona a base URL do backend
  let finalUrl;
  if (imagePath.startsWith('/')) {
    finalUrl = `${API_BASE_URL}${imagePath}`;
  } else {
    finalUrl = `${API_BASE_URL}/${imagePath}`;
  }

  // Armazena em cache
  urlCache[imagePath] = finalUrl;
  
  return finalUrl;
}
